<template>
  <cloud-image-fi
    v-if="navImage"
    :src="navImage"
    :alt="`${navIndex}`"
    class="navigation-image-fi"
  />
</template>

<script setup lang="ts">
import { CloudImageFi } from 'atoms';
import { computed } from 'vue';

import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'NavigationImageFi' });

const navigationStore = useNavigationStore();

const navIndex = computed(() => navigationStore.navIndex);

const navImage = computed(() => navigationStore.groupData?.teaserImage?.src);
</script>

<style scoped src="./navigation-image-fi" />
